import { sessionClient } from "@/di/api";
import { userRepo } from "@/di/repositories";
import qs from "qs";
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import paths from "./paths";

async function loginWithBearerToken(query: Record<string, any>): Promise<boolean> {
  try {
    sessionClient.saveAuthToken(query.token);
    const user = await userRepo.getUserById(Number(query.user_id));
    if (user.type === "psychologist") {
      sessionClient.saveSession(user);
      return true;
    }
    return false;
  } catch (error) {
    console.error("loginWithBearerToken", error);
    return false;
  }
}

const routes: Array<RouteRecordRaw> = [
  {
    path: paths.home,
    name: "Home",
    alias: "/",
    component: () => import("../views/Home/Home.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: paths.login,
    name: "Login",
    component: () => import("../views/Login/Login.vue"),
  },
  {
    path: paths.forgot_password,
    name: "ForgotPassword",
    component: () => import("../views/ForgotPassword/ForgotPassword.vue"),
  },
  {
    path: paths.reset_password,
    name: "ResetPassword",
    component: () => import("../views/ResetPassword/ResetPassword.vue"),
  },
  {
    alias: paths.register,
    path: `${paths.register}/:step?`,
    name: "Register",
    component: () => import("../views/Register/Register.vue"),
  },
  {
    path: paths.onHolding,
    name: "OnHolding",
    component: () => import("../views/Register/OnHolding/OnHolding.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: paths.addBankAccount,
    name: "AddBankAccount",
    component: () =>
      import("../views/Register/AddBankAccount/AddBankAccount.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: paths.chat.list,
    name: "Chat",
    component: () => import("../views/Chat/Chat.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: `${paths.financial.list}/:path?`,
    name: "Financial",
    component: () => import("../views/Financial/Financial.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: paths.appointments.list,
    name: "Appointments",
    component: () => import("../views/Appointments/Appointments.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: `${paths.appointments.room}/:id`,
    name: "AppointmentRoom",
    component: () =>
      import("../views/Appointments/AppointmentRoom/AppointmentRoom.vue"),
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: `${paths.more}/:path?`,
    name: "More",
    component: () => import("../views/More/More.vue"),
    // meta: { requiresAuth: true },
    props: true,
  },
  {
    path: paths.not_found,
    name: "NotFound",
    component: () => import("../views/NotFound/NotFound.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: {
      name: "NotFound",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const session = sessionClient.getSession();

  if (to.query.token && to.query.user_id) {
    const logged = session && session.id == parseInt(to.query.user_id as string);
    if (!logged) {
      const ok = await loginWithBearerToken(to.query);
      if (!ok) sessionClient.destroySession();
    }
    delete to.query.token;
    delete to.query.user_id;
    next(`${to.path}?${qs.stringify(to.query)}`);
    return;
  }

  if (to.meta.requiresAuth && !session) {
    next(paths.login);
    return;
  }

  if (
    to.meta.requiresAuth &&
    to.path !== paths.onHolding &&
    to.path !== paths.addBankAccount &&
    session &&
    (session as import("@phurshell/psiapp-frontend-core/domain").UserPsi).on_holding
  ) {
    next(paths.onHolding);
    return;
  }

  next();
});

export default router;
